<template>
  <div class="date-rule">
    <MDateTimePicker v-model="localModal" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import MDateTimePicker from "@/BasicComponentLibrary/MDateAndTimePicker.vue";

const props = defineProps<{ value: string }>();
const emits = defineEmits(["input"]);

const localModal = computed({
  get: () => {
    return props.value;
  },
  set: (nv) => {
    emits("input", nv);
  }
});
</script>
